import * as AppStorage from './storage/appstorage';

export default {
  items: [
    {
      name: 'Главная',
      url: '/dashboard',
      icon: 'icon-speedometer',
      /*badge: {
        variant: 'primary',
        text: 'NEW'
      }*/
    },
    {
      title: true,
      name: 'Отбор',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
      /*
      *  {
      name: 'Colors',
      url: '/theme/colors',
      icon: 'icon-drop'
    },
    {
      name: 'Typography',
      url: '/theme/typography',
      icon: 'icon-pencil'
    },
    {
      title: true,
      name: 'Components',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }*/
    {
      name: 'В процессе верификации',
      url: '/dashboard?status=verify',
      icon: 'icon-people'
    },
    {
        name: 'Участники мероприятий',
        url: '/dashboard?status=event',
        icon: 'icon-user-follow'
    },
    {
        name: 'Кандидаты',
        url: '/dashboard?status=candidate',
        icon: 'icon-user-following'
    },
    {
      name: 'Завершили обучение',
      url: '/dashboard?status=complete',
      icon: 'icon-user-following'
    },
    {
      name: 'Архив',
      url: '/dashboard?status=archive',
      icon: 'icon-user-unfollow'
    },
    {
      name: 'Потоки обучения',
      url: '/groups',
      icon: 'fa fa-group'
    },
      {
          title: true,
          name: 'Система',
          disabled: AppStorage.get('user') === null || (JSON.parse(AppStorage.get('user')).roles.indexOf('ROLE_SUPER_ADMIN') === -1),
          class: '',
          wrapper: {
              element: '',
              attributes: {}
          }
      },
    /*{
      name: 'Настройки',
      url: '/settings',
      icon: 'icon-settings',
      /!*attributes: { disabled: true },*!/
    },*/
    {
        name: 'Отчеты',
        disabled: AppStorage.get('user') === null || (JSON.parse(AppStorage.get('user')).roles.indexOf('ROLE_SUPER_ADMIN') === -1),
        icon: 'icon-pie-chart',
        children: [
            {
                name: 'Этап верификации',
                url: '/reports',
                icon: 'icon-puzzle'
            },
            {
                name: 'Этап комплексной диагностики',
                url: '/complex-reports',
                icon: 'icon-puzzle'
            }
        ]
    },
      /*{
          name: 'Base',
          url: '/base',
          icon: 'icon-puzzle',
          children: [
              {
                  name: 'Breadcrumbs',
                  url: '/base/breadcrumbs',
                  icon: 'icon-puzzle'
              },
              {
                  name: 'Cards',
                  url: '/base/cards',
                  icon: 'icon-puzzle'
              },
              {
                  name: 'Carousels',
                  url: '/base/carousels',
                  icon: 'icon-puzzle'
              },
              {
                  name: 'Collapses',
                  url: '/base/collapses',
                  icon: 'icon-puzzle'
              },
              {
                  name: 'Forms',
                  url: '/base/forms',
                  icon: 'icon-puzzle'
              },
              {
                  name: 'Jumbotrons',
                  url: '/base/jumbotrons',
                  icon: 'icon-puzzle'
              },
              {
                  name: 'List Groups',
                  url: '/base/list-groups',
                  icon: 'icon-puzzle'
              },
              {
                  name: 'Navs',
                  url: '/base/navs',
                  icon: 'icon-puzzle'
              },
              {
                  name: 'Navbars',
                  url: '/base/navbars',
                  icon: 'icon-puzzle'
              },
              {
                  name: 'Paginations',
                  url: '/base/paginations',
                  icon: 'icon-puzzle'
              },
              {
                  name: 'Popovers',
                  url: '/base/popovers',
                  icon: 'icon-puzzle'
              },
              {
                  name: 'Progress Bars',
                  url: '/base/progress-bars',
                  icon: 'icon-puzzle'
              },
              {
                  name: 'Switches',
                  url: '/base/switches',
                  icon: 'icon-puzzle'
              },
              {
                  name: 'Tables',
                  url: '/base/tables',
                  icon: 'icon-puzzle'
              },
              {
                  name: 'Tabs',
                  url: '/base/tabs',
                  icon: 'icon-puzzle'
              },
              {
                  name: 'Tooltips',
                  url: '/base/tooltips',
                  icon: 'icon-puzzle'
              }
          ]
      },
      {
          name: 'Buttons',
          url: '/buttons',
          icon: 'icon-cursor',
          children: [
              {
                  name: 'Buttons',
                  url: '/buttons/standard-buttons',
                  icon: 'icon-cursor'
              },
              {
                  name: 'Button Dropdowns',
                  url: '/buttons/dropdowns',
                  icon: 'icon-cursor'
              },
              {
                  name: 'Button Groups',
                  url: '/buttons/button-groups',
                  icon: 'icon-cursor'
              },
              {
                  name: 'Brand Buttons',
                  url: '/buttons/brand-buttons',
                  icon: 'icon-cursor'
              }
          ]
      },
      {
          name: 'Charts',
          url: '/charts',
          icon: 'icon-pie-chart'
      },
      {
          name: 'Icons',
          url: '/icons',
          icon: 'icon-star',
          children: [
              {
                  name: 'CoreUI Icons',
                  url: '/icons/coreui-icons',
                  icon: 'icon-star',
                  badge: {
                      variant: 'info',
                      text: 'NEW'
                  }
              },
              {
                  name: 'Flags',
                  url: '/icons/flags',
                  icon: 'icon-star'
              },
              {
                  name: 'Font Awesome',
                  url: '/icons/font-awesome',
                  icon: 'icon-star',
                  badge: {
                      variant: 'secondary',
                      text: '4.7'
                  }
              },
              {
                  name: 'Simple Line Icons',
                  url: '/icons/simple-line-icons',
                  icon: 'icon-star'
              }
          ]
      },
      {
          name: 'Notifications',
          url: '/notifications',
          icon: 'icon-bell',
          children: [
              {
                  name: 'Alerts',
                  url: '/notifications/alerts',
                  icon: 'icon-bell'
              },
              {
                  name: 'Badges',
                  url: '/notifications/badges',
                  icon: 'icon-bell'
              },
              {
                  name: 'Modals',
                  url: '/notifications/modals',
                  icon: 'icon-bell'
              }
          ]
      },
      {
          name: 'Widgets',
          url: '/widgets',
          icon: 'icon-calculator',
          badge: {
              variant: 'primary',
              text: 'NEW'
          }
      },
      {
          divider: true
      },
      {
          title: true,
          name: 'Extras'
      },
      {
          name: 'Pages',
          url: '/pages',
          icon: 'icon-star',
          children: [
              {
                  name: 'Login',
                  url: '/pages/login',
                  icon: 'icon-star'
              },
              {
                  name: 'Register',
                  url: '/pages/register',
                  icon: 'icon-star'
              },
              {
                  name: 'Error 404',
                  url: '/pages/404',
                  icon: 'icon-star'
              },
              {
                  name: 'Error 500',
                  url: '/pages/500',
                  icon: 'icon-star'
              }
          ]
      }*/
  ]
}
